const OWNER_KEY = 'youraura_active_user';
const legacyKeys = [
  'youraura_relationship_memory',
  'planetary_impact_checks',
  'day_decoder_pending_activity',
  'youraura_reminder_preferences',
];

export function privateStorageKey(key: string) {
  const owner =
    typeof window === 'undefined' ? 'guest' : window.localStorage.getItem(OWNER_KEY) || 'guest';
  return `youraura_private:${owner}:${key}`;
}

export function setStorageOwner(userId?: string) {
  if (typeof window === 'undefined') return;
  const previous = window.localStorage.getItem(OWNER_KEY);
  if (previous !== (userId || null)) {
    for (const key of Object.keys(window.localStorage)) {
      if (
        key.startsWith('youraura_private:') ||
        key.startsWith('palm_') ||
        legacyKeys.includes(key)
      )
        window.localStorage.removeItem(key);
    }
  }
  if (userId) window.localStorage.setItem(OWNER_KEY, userId);
  else window.localStorage.removeItem(OWNER_KEY);
}
